import { useEffect, useState } from "react";

const getViewportWidth = () =>
  typeof window === "undefined" ? 1280 : window.innerWidth;

const sizeForViewport = (viewportWidth, laptop, desktop, wide) => {
  if (viewportWidth < 768) {
    return Math.max(viewportWidth - 24, 320);
  }
  if (viewportWidth < 1600) {
    return laptop;
  }
  if (viewportWidth < 1920) {
    return desktop;
  }
  return wide;
};

export const getFeatureNewsViewerWidth = (viewportWidth = getViewportWidth()) =>
  sizeForViewport(viewportWidth, 460, 560, 640);

export const getFeatureNewsAdminWidth = (mode = "list", viewportWidth = getViewportWidth()) => {
  if (mode === "form") {
    return sizeForViewport(viewportWidth, 720, 900, 1040);
  }
  return sizeForViewport(viewportWidth, 560, 640, 720);
};

export const useFeatureNewsPanelSize = (mode = "list") => {
  const [viewportWidth, setViewportWidth] = useState(getViewportWidth);

  useEffect(() => {
    const updateSize = () => setViewportWidth(getViewportWidth());
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return {
    viewerWidth: getFeatureNewsViewerWidth(viewportWidth),
    adminWidth: getFeatureNewsAdminWidth(mode, viewportWidth),
  };
};
